import dayjs, { type Dayjs } from 'dayjs'

export enum WeekDay {
  Sunday,
  Monday,
  Tuesday,
  Wednesday,
  Thursday,
  Friday,
  Saturday,
}

/* eslint-disable no-else-return */
export const getNextBusinessDay = (excludedWeekDays: WeekDay[]) => {
  const next = dayjs().add(1, 'day').startOf('hour')
  const nextDay = next.day()
  if (nextDay === WeekDay.Sunday && excludedWeekDays.includes(WeekDay.Sunday)) {
    return next.add(1, 'day')
  } else if (nextDay === WeekDay.Saturday && excludedWeekDays.includes(WeekDay.Saturday)) {
    return next.add(2, 'day')
  } else {
    return next
  }
}
/* eslint-enable no-else-return */

export const formatTime = (time: string) => dayjs(time, 'HHmm').format('HH:mm')

export const isToday = (date: Dayjs | null) => !!date && date.startOf('d').isSame(dayjs().startOf('d'))
